import { guidFor } from '@ember/object/internals';
import { Promise as EmberPromise } from 'rsvp';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import loadImage from 'load-image';
import { findNodeByFileGUID, applyNewAttrsToFileNode } from './file';
import { updateImageSizesPluginKey } from '../config/update-image-sizes-plugin';
//prettier-ignore
//Source https://github.com/mathiasbynens/small/blob/1feb485cfaf6af4019ff4af54e2747c7fc99a070/png-transparent.png, resized to 10x10
const FAKE_PNG_VALUES = [-119, 80, 78, 71, 13, 10, 26, 10, 0, 0, 0, 13, 73, 72, 68, 82, 0, 0, 0, 10, 0, 0, 0, 10, 8, 6, 0, 0, 0, -115, 50, -49, -67, 0, 0, 0, 1, 115, 82, 71, 66, 0, -82, -50, 28, -23, 0, 0, 0, -124, 101, 88, 73, 102, 77, 77, 0, 42, 0, 0, 0, 8, 0, 5, 1, 18, 0, 3, 0, 0, 0, 1, 0, 1, 0, 0, 1, 26, 0, 5, 0, 0, 0, 1, 0, 0, 0, 74, 1, 27, 0, 5, 0, 0, 0, 1, 0, 0, 0, 82, 1, 40, 0, 3, 0, 0, 0, 1, 0, 2, 0, 0, -121, 105, 0, 4, 0, 0, 0, 1, 0, 0, 0, 90, 0, 0, 0, 0, 0, 0, 0, 72, 0, 0, 0, 1, 0, 0, 0, 72, 0, 0, 0, 1, 0, 3, -96, 1, 0, 3, 0, 0, 0, 1, 0, 1, 0, 0, -96, 2, 0, 4, 0, 0, 0, 1, 0, 0, 0, 10, -96, 3, 0, 4, 0, 0, 0, 1, 0, 0, 0, 10, 0, 0, 0, 0, -56, 66, -43, -10, 0, 0, 0, 9, 112, 72, 89, 115, 0, 0, 11, 19, 0, 0, 11, 19, 1, 0, -102, -100, 24, 0, 0, 1, 89, 105, 84, 88, 116, 88, 77, 76, 58, 99, 111, 109, 46, 97, 100, 111, 98, 101, 46, 120, 109, 112, 0, 0, 0, 0, 0, 60, 120, 58, 120, 109, 112, 109, 101, 116, 97, 32, 120, 109, 108, 110, 115, 58, 120, 61, 34, 97, 100, 111, 98, 101, 58, 110, 115, 58, 109, 101, 116, 97, 47, 34, 32, 120, 58, 120, 109, 112, 116, 107, 61, 34, 88, 77, 80, 32, 67, 111, 114, 101, 32, 53, 46, 52, 46, 48, 34, 62, 10, 32, 32, 32, 60, 114, 100, 102, 58, 82, 68, 70, 32, 120, 109, 108, 110, 115, 58, 114, 100, 102, 61, 34, 104, 116, 116, 112, 58, 47, 47, 119, 119, 119, 46, 119, 51, 46, 111, 114, 103, 47, 49, 57, 57, 57, 47, 48, 50, 47, 50, 50, 45, 114, 100, 102, 45, 115, 121, 110, 116, 97, 120, 45, 110, 115, 35, 34, 62, 10, 32, 32, 32, 32, 32, 32, 60, 114, 100, 102, 58, 68, 101, 115, 99, 114, 105, 112, 116, 105, 111, 110, 32, 114, 100, 102, 58, 97, 98, 111, 117, 116, 61, 34, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 120, 109, 108, 110, 115, 58, 116, 105, 102, 102, 61, 34, 104, 116, 116, 112, 58, 47, 47, 110, 115, 46, 97, 100, 111, 98, 101, 46, 99, 111, 109, 47, 116, 105, 102, 102, 47, 49, 46, 48, 47, 34, 62, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 60, 116, 105, 102, 102, 58, 79, 114, 105, 101, 110, 116, 97, 116, 105, 111, 110, 62, 49, 60, 47, 116, 105, 102, 102, 58, 79, 114, 105, 101, 110, 116, 97, 116, 105, 111, 110, 62, 10, 32, 32, 32, 32, 32, 32, 60, 47, 114, 100, 102, 58, 68, 101, 115, 99, 114, 105, 112, 116, 105, 111, 110, 62, 10, 32, 32, 32, 60, 47, 114, 100, 102, 58, 82, 68, 70, 62, 10, 60, 47, 120, 58, 120, 109, 112, 109, 101, 116, 97, 62, 10, 76, -62, 39, 89, 0, 0, 0, 14, 73, 68, 65, 84, 24, 25, 99, 96, 24, 5, -125, 51, 4, 0, 1, -102, 0, 1, 120, 54, 52, 15, 0, 0, 0, 0, 73, 69, 78, 68, -82, 66, 96, -126];
export const FAKE_PNG_HEIGHT = 10;
export const FAKE_PNG_WIDTH = 10;
export function generateFakePng() {
  return new Int8Array(FAKE_PNG_VALUES).buffer;
}
export function updateImageNodeWithProcessingResult(editorView, processingResult, defaultAttrs = {}) {
  let pos = findNodeByFileGUID(editorView, processingResult.oldGuid);
  if (pos.fileNode) {
    let attrs = Object.assign({}, pos.fileNode.attrs, {
      width: processingResult.width,
      height: processingResult.height,
      src: processingResult.tempUrl,
      fileGUID: processingResult.newGuid,
      ...defaultAttrs
    });
    applyNewAttrsToFileNode(editorView, pos, attrs);
  }
}
export async function processImageFile(file) {
  let rotatedFile = await rotate(file);
  let {
    width,
    height
  } = await load(rotatedFile);
  return {
    width,
    height,
    file: rotatedFile,
    tempUrl: window.URL.createObjectURL(rotatedFile),
    oldGuid: guidFor(file),
    newGuid: guidFor(rotatedFile)
  };
}
export async function load(fileOrURL) {
  return new EmberPromise(function (resolve) {
    loadImage(fileOrURL, img => {
      resolve({
        width: Math.round(img.width),
        height: Math.round(img.height)
      });
    });
  });
}
async function rotate(file) {
  if (file.type !== 'image/jpeg') {
    return Promise.resolve(file);
  }
  return new EmberPromise(function (resolve) {
    loadImage(file, canvas => {
      canvas.toBlob(blob => {
        blob.name = file.name;
        if (blob) {
          resolve(blob);
        }
      }, file.type);
    }, {
      orientation: true,
      canvas: true
    });
  });
}
export function dispatchImageUpdate(config, transaction, dispatch) {
  if (!config.resizeImages) {
    return;
  }
  transaction.setMeta(updateImageSizesPluginKey, {
    updateSizes: true
  });
  dispatch(transaction);
}